"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.get")),
    _classnames = _interopRequireDefault(require("classnames")),
    _DrawerTrigger = _interopRequireDefault(require("./DrawerTrigger")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _Tabs = _interopRequireDefault(require("../../Tabs")),
    _drawer = require("../styles/drawer");

require("../styles/_drawer.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var Drawer = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.toggleMinimiseState = function () {
      d.setState(function (a) {
        var b = a.minimised;
        return {
          minimised: !b
        };
      }, function () {
        var a = d.state.minimised,
            b = d.props.onToggleExpanded;
        b && b(a);
      });
    }, d.setTabIndex = function (a) {
      d.setState({
        selectedTab: a
      });
    }, d.onMouseOver = function () {
      var a = d.state.showExpand,
          b = d.props.isExpandable;
      a || !b || d.setState({
        showExpand: !0
      });
    }, d.onMouseOut = function (a) {
      var b = a.relatedTarget,
          c = (0, _lodash["default"])(d._menu, "current") && b && d._menu.current.contains(b),
          e = d.state.showExpand,
          f = d.props.showExpandOnHover;

      !c && e && f && d.setState({
        showExpand: !1
      });
    }, d.state = {
      minimised: !a.startOpen,
      selectedTab: 0,
      showExpand: !a.startOpen && !a.showExpandOnHover && a.isExpandable
    }, d._menu = _react["default"].createRef(), d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a,
          b = this.props,
          c = b.menuColor,
          d = b.minimisedWidth,
          e = b.align,
          f = b.tabs,
          g = b.isExpandable,
          h = b.renderChildrenMinimised,
          i = b.children,
          j = b.width,
          k = b.aboveContent,
          l = b.className,
          m = this.state,
          n = m.minimised,
          o = m.selectedTab,
          p = m.showExpand,
          q = 1 < _react.Children.count(i),
          r = f && i && q ? Array.from(i) : i;

      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
        ref: this._menu,
        role: "button",
        className: (0, _classnames["default"])("drawer", "drawer--".concat(e, "-align"), (0, _drawer.MENU_CONTAINER)({
          width: j
        }), (a = {
          "drawer--above-content": k
        }, (0, _defineProperty2["default"])(a, (0, _drawer.MINIMISED_MENU)({
          minimisedWidth: d
        }), n), (0, _defineProperty2["default"])(a, "drawer--minimised", n), a), l),
        onMouseOver: this.onMouseOver,
        onMouseOut: this.onMouseOut,
        onFocus: this.onMouseOver,
        onBlur: this.onMouseOut,
        tabIndex: 0
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])("drawer__menu", (0, _drawer.MENU)(c, e, j, {
          hideBorder: n && 0 === d || k
        }), (0, _defineProperty2["default"])({}, (0, _drawer.MINIMISED_MENU)({
          minimisedWidth: d
        }), n))
      }, k && !n ? _react["default"].createElement(_Icon["default"], {
        className: "drawer__menu__close",
        name: "close",
        color: "regent",
        onClick: this.toggleMinimiseState,
        hoverColor: "denim",
        size: 15
      }) : null, g ? _react["default"].createElement("button", {
        type: "button",
        className: (0, _classnames["default"])("drawer__menu__expand-btn", "drawer__menu__expand-btn--".concat(e, "-align"), {
          "drawer__menu__expand-btn--visible": p
        }),
        onClick: this.toggleMinimiseState
      }, _react["default"].createElement(_Icon["default"], {
        name: n && "left" === e || !n && "right" === e ? "chevronright" : "chevronleft",
        size: 10,
        color: "denim"
      })) : null, f && (h || !n) ? _react["default"].createElement(_Tabs["default"], {
        updateSelectedTabIndex: this.setTabIndex,
        selectedIndex: o
      }, q ? r.map(function (a, b) {
        return (0, _react.cloneElement)(a, {
          title: f[b]
        });
      }) : (0, _react.cloneElement)(r, {
        title: f[0]
      })) : null, f || !h && n ? null : r)), k ? _react["default"].createElement("button", {
        onClick: this.toggleMinimiseState,
        className: (0, _classnames["default"])("drawer__overlay", {
          "drawer__overlay--visible": !n
        })
      }) : null);
    }
  }]), b;
}(_react.Component);

exports["default"] = Drawer, Drawer.displayName = "Drawer", Drawer.defaultProps = {
  isExpandable: !0,
  align: "left",
  minimisedWidth: 20,
  width: 320,
  showExpandOnHover: !1
}, Drawer.DrawerTrigger = _DrawerTrigger["default"];